module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "lo"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "gb"
  }, [_vm._v("To George Landon, who didn’t teach me "), _c('span', {
    staticClass: "bold6"
  }, [_vm._v("how")]), _vm._v(" to write so much as "), _c('span', {
    staticClass: "bold6"
  }, [_vm._v("why")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2db446e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LO-06.vue
// module id = 69
// module chunks = 0